package one.healthium.meal_plans.tutorial.screen

import androidx.compose.runtime.Immutable

@Immutable
internal data class PersonalMealPlanTutorialUiState(
    val loading: Boolean = false,
)
